export const poshak = [
  {
    name: 'Mor Poshak (Set of 6)',
    imgUrl:
      'https://ik.imagekit.io/xe9lmicvfek/Poshak/00001-01_TNw0cNW1K.png?tr=w-00,h-200',
    desc: 'Poshak for laddu gopal',
    cost: 1000,
  },
  {
    name: 'Mor Poshak (Set of 4)',
    imgUrl:
      'https://ik.imagekit.io/xe9lmicvfek/Poshak/00002-01_xeilx5-R2.png',
    desc: 'Poshak for laddu gopal',
    cost: 1000,
  },
  {
    name: 'Fancy Poshak (Set of 4)',
    imgUrl:
      'https://ik.imagekit.io/xe9lmicvfek/Poshak/00003-01_2dg9cLBzyf.png',
    desc: 'Poshak for laddu gopal',
    cost: 1000,
  },
  {
    name: 'Flower Poshak (Set of 6)',
    imgUrl:
      'https://ik.imagekit.io/xe9lmicvfek/Poshak/00004-01_7RTMPe4GY.png',
    desc: 'Poshak for laddu gopal',
    cost: 1500,
  },
  {
    name: 'Flower Poshak (Set of 6)',
    imgUrl:
      'https://ik.imagekit.io/xe9lmicvfek/Poshak/00005/5no_lowres_qqtiyLM33W.jpg?tr=w-280,h-200',
    desc: 'Poshak for laddu gopal',
    cost: 1500,
  },
]
//?tr=w-640,h-480
